exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-form-new-business-unit-component .upload{width:100%}.modal-form-new-business-unit-component .upload .upload-draggable{width:100%}", ""]);

// exports
